// iconMapping.ts
import {
  AppstoreOutlined,
  BankOutlined,
  BgColorsOutlined,
  CalendarOutlined,
  CameraOutlined,
  ClockCircleOutlined,
  CodeOutlined,
  ControlOutlined,
  CreditCardOutlined,
  CrownOutlined,
  DashboardOutlined,
  DesktopOutlined,
  DollarOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  FileSyncOutlined,
  FileTextOutlined,
  IdcardOutlined,
  KeyOutlined,
  LineChartOutlined,
  LinkOutlined,
  LockOutlined,
  MailOutlined,
  MessageOutlined,
  NotificationOutlined,
  PieChartOutlined,
  PlusOutlined,
  ProfileOutlined,
  ProjectOutlined,
  QuestionCircleOutlined,
  ReadOutlined,
  SafetyCertificateOutlined,
  SafetyOutlined,
  ScheduleOutlined,
  SearchOutlined,
  SettingOutlined,
  ShareAltOutlined,
  SolutionOutlined,
  SwapOutlined,
  TabletOutlined,
  TeamOutlined,
  ToolOutlined,
  TranslationOutlined,
  TrophyOutlined,
  UnorderedListOutlined,
  UserAddOutlined,
  UserOutlined,
  UserSwitchOutlined,
  VideoCameraOutlined,
  WalletOutlined
} from '@ant-design/icons';
import { ReactNode } from 'react';

// Define a reusable icon mapping
export const iconMapping: Record<string, ReactNode> = {
  'Dashboard': <AppstoreOutlined />,
  'Monitoring': <EyeOutlined />,
  'Snapshots': <CameraOutlined />,
  'Console Commands': <CodeOutlined />,
  'Emailing': <MailOutlined />,
  'File Transfers': <FileSyncOutlined />,
  'Online Meetings': <UserSwitchOutlined />,
  'Instant Messaging': <MessageOutlined />,
  'Social Media': <ShareAltOutlined />,
  'Employee Management': <TeamOutlined />,
  Onboarding: <SolutionOutlined />,
  'Employee Registration': <UserAddOutlined />,
  'Device List': <TabletOutlined />,
  'Employees': <UserOutlined />,
  'System Support': <ToolOutlined />,
  Configuration: <ControlOutlined />,
  "Settings": <SettingOutlined />,
  'Help Center': <QuestionCircleOutlined />,
  Searches: <SearchOutlined />,
  Keystrokes: <KeyOutlined />,
  'Websites': <LinkOutlined />,
  'Applications': <AppstoreOutlined />,
  'Time Tracking': <ClockCircleOutlined />,
  'All Tasks': <UnorderedListOutlined />,
  'Employee Cost': <TeamOutlined />,
  'Task Cost': <DollarOutlined />,
  'Time Records': <ClockCircleOutlined />,
  'Employee Details': <IdcardOutlined />,
  'Manage Account': <WalletOutlined />,
  'Billing': <CreditCardOutlined />,
  'Change Password': <LockOutlined />,
  Reports: <FileTextOutlined />,
  Attendance: <CalendarOutlined />,
  "Daily Report": <FileTextOutlined />,
  "Monthly Report": <PieChartOutlined />,
  "Daily Work Load": <ScheduleOutlined />,
  "Risk User": <ExclamationCircleOutlined />,
  "Organization Profile": <BankOutlined />,
  "Screen Records": <VideoCameraOutlined />,
  "Organization": <BankOutlined />,
  "Restriction": <LockOutlined />,
  "Date": <CalendarOutlined />,
  "Language": <TranslationOutlined />,
  "Theme": <BgColorsOutlined />,
  "Organization Management": <BankOutlined />,
  "Account": <IdcardOutlined />,
  "Context Switching": <SwapOutlined />,
  "Supervisor Management": <UserSwitchOutlined />,
  "Risk User Settings": <SafetyOutlined />,
  "Email Report": <MailOutlined />,
  "Monitoring Configuration": <EyeOutlined />,
  "Top Supervisors": <CrownOutlined />,
  "Roles & Privileges": <SafetyCertificateOutlined />,
  "Assign Roles": <UserOutlined />,
  "Meeting Report": <FileTextOutlined />,
  "Top Employees": <TrophyOutlined />,
  "Promotional Content": <NotificationOutlined />,
  "Manage Project": <ControlOutlined />,
  "Project Details": <ReadOutlined />,
  "Project Management": <ProjectOutlined />,
  "Tasks": <UnorderedListOutlined />,
  "Timesheets": <ClockCircleOutlined />,
  "Overview": <DashboardOutlined />,
  "Projects": <ProjectOutlined />,
  "Project Reports": <FileTextOutlined />,
  "Team Workload": <TeamOutlined />,
  "Task Details": <ReadOutlined />,
  "Task Monitoring": <EyeOutlined />,
  "Task Activity Chart": <LineChartOutlined />,
  "Create Task": <PlusOutlined />,
  "Create Project": <PlusOutlined />,
  "Edit Task": <EditOutlined />,
  "Edit Project": <EditOutlined />,
  "Drive Log": <FileTextOutlined />,
  "AutoGraph": <FileTextOutlined />,
  "System Activity": <DesktopOutlined />,
  "Work Activity": <ProfileOutlined />,
  "Screen Activity": <MessageOutlined />,
  "Communications": <SettingOutlined />,
  "Task Configuration": <SettingOutlined />,
  "Task Activity Attendance": <CalendarOutlined />,
  "AI Model Settings": <SettingOutlined />,
};

// Utility function to get icon by key
export const getIconByName = (name: string) =>
  iconMapping[name] || <DashboardOutlined />;
